





























import { Vue, Prop, Component } from "vue-property-decorator";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";

@Component
export default class CopiedTestQuestionItem extends Vue {
  @Prop() question!: ITestQuestion;
  @Prop() index?: number;
  isShowFullBody?: boolean = false;

  checkCorrect(value: boolean) {
    return value;
  }

  get filteredBody() {
    return this.question.body?.length > 50
      ? this.question.body.substring(0, 50) + "..."
      : this.question.body;
  }

  filteredAnswer(value: string) {
    return value.length > 50 ? value.substring(0, 50) + "..." : value;
  }

  deleteQuestion() {
    this.$store.commit(
      "tests/TestsQuestions/DELETE_QUESTION",
      this.question.id
    );
  }
}
